import { EventServiceFacade, isNative, JWebErrorHandler } from '../../JWeb';
import { Publisher, Subscriber } from '../../JWeb/types';
import { publisherId } from '../utils';

export const nativeEventPublisherPromise: Promise<Publisher> = (async () => {
  if (await isNative()) {
    const nativeEventPublisher = await EventServiceFacade.createPublisher(
      publisherId
    );

    return JWebErrorHandler<Publisher>(nativeEventPublisher);
  }
})();

export const nativeSubscriberPromise = (async () => {
  if (await isNative()) {
    return await EventServiceFacade.createSubscriber().then((v) =>
      JWebErrorHandler<Subscriber>(v)
    );
  }
})();
